/**
 * The constants that can be used all over the app.
 *
 * Please, include here ONLY the values that will be used frequently.
 */
export const Constants = {
  ASC_DIR: 'asc',
  DESC_DIR: 'desc',
  DATATABLE_INITAL_PAGE: '0',
  DATATABLE_PAGE_SIZE: '10'
};

/** Field types */
export enum FieldType {
  NUMBER = 'num',
  STRING = 'string',
  BOOLEAN = 'bool',
  DATE = 'date',
  UUID = 'uuid',
  TABLE = 'table',
  CUSTOM = 'custom',
  HIERARCHY = 'hierarchy'
}

/**
 * Material Icons used in the app
 */
export const Icons = {
  SETTINGS: 'settings',
  ACCOUNT_BOX: 'account_box',
  PERM_IDENTITY: 'perm_identity',
  LOCK: 'lock',
  TERRAIN: 'terrain',
  PETS: 'pets',
  DONUT_SMALL: 'donut_small',
  AIRPLANEMODE_ACTIVE: 'airplanemode_active',
  HOME: 'home',
  ACCOUNT_CIRCLE: 'account_circle',
  ADD_CIRCLE: 'add_circle',
  ARROW_DOWNWARD: 'arrow_downward',
  ARROW_UPWARD: 'arrow_upward',
  ARROW_BACK: 'arrow_back',
  FORMAT_ALIGN_LEFT: 'format_align_left',
  FORMAT_ALIGN_CENTER: 'format_align_center',
  FORMAT_ALIGN_RIGHT: 'format_align_right',
  CLOSE: 'close',
  FLIGHT: 'flight',
  VIEW_LIST: 'view_list',
  VIEW_MODULE: 'view_module',
  ACCOUNT_BADGE_O: 'account_badge_o',
  OPEN_IN_NEW: 'open_in_new',
  BRING: 'bring',
  DESKTOP_WINDOWS: 'desktop_windows',
  DEVICES_DESK: 'devices_desk',
  PHONE_IPHONE: 'phone_iphone',
  ANNOUNCEMENT: 'announcement',
  SORT_ASC: 'sort',
  SORT_DESC: 'sort_reversed',
  PERSON_OUTLINE: 'person_outline',
  FILE_UPLOAD: 'file_upload',
  ATTACHMENT: 'attachment',
  REFRESH: 'refresh',
  FOLDER_SHARED: 'folder_shared',
  MARKUNREAD: 'markunread',
  DELETE: 'delete',
  MODE_EDIT: 'mode_edit',
  TOGGLE_OFF: 'toggle_off',
  EDIT: 'edit',
  BLOCK: 'block',
  ASSIGNMENT_IND: 'assignment_ind',
  FILE_COPY: 'file_copy',
  CONTENT_COPY: 'content_copy',
  FOLDER: 'folder',
  LINK: 'link',
  HEADSET: 'headset',
  CHECK_CIRCLE: 'check_circle',
  MENU_EDIT: 'menu_edit',
  WARNING: 'warning',
  VPN_KEY: 'vpn_key'
};

export enum Platform {
  BACKOFFICE = 'BACKOFFICE',
  REMOTE = 'REMOTE',
  BOTH = 'BOTH',
  NONE = 'NONE'
}

export enum BooleanEnumerable {
  TRUE = 'true',
  FALSE = 'false'
}

/**
 * Permissions used in the app
 */
// FIXME: check if this permissions MUST be used by ALL features in the app, or if it must be removed.
export const Permissions = {
  CRE_B2B_ACCESS: 'CRE_BO_ACCESS_B2B', // TODO: Fix rights below this one
  USR_BO_CREATE_DEVICE: 'USR_BO_CREATE_DEVICE',
  USR_BO_ACTIVATE_AND_DEACTIVATE_DEVICE: 'USR_BO_ACTIVATE_AND_DEACTIVATE_DEVICE',
  USR_BO_IMPORT_USER_LIST: 'USR_BO_IMPORT_USER_LIST',
  USR_BO_WRITE_DEVICE: 'USR_BO_WRITE_DEVICE',
  USR_BO_EXPORT_DEVICE_LIST: 'USR_BO_EXPORT_DEVICE_LIST',
  USR_BO_READ_LICENSE_INFORMATION: 'USR_BO_READ_LICENSE_INFORMATION',
  USR_BO_ACCESS_DEVICE_SYNCHRONIZATION_LOG: 'USR_BO_ACCESS_DEVICE_SYNCHRONIZATION_LOG',
  USR_BO_IMPORT_DEVICE_LIST: 'USR_BO_IMPORT_DEVICE_LIST',
  USR_BO_SEND_PASSWORD_EMAIL: 'USR_BO_SEND_PASSWORD_EMAIL',
  USR_BO_WRITE_PROFILE: 'USR_BO_WRITE_PROFILE',
  USR_BO_EXPORT_PROFILE_LIST: 'USR_BO_EXPORT_PROFILE_LIST',
  USR_BO_EXPORT_USER_LIST: 'USR_BO_EXPORT_USER_LIST',
  USR_BO_WRITE_USER: 'USR_BO_WRITE_USER',
  USR_BO_ACTIVATE_AND_DEACTIVATE_USER: 'USR_BO_ACTIVATE_AND_DEACTIVATE_USER',
  USR_BO_ACTIVATE_AND_DEACTIVATE_PROFILE: 'USR_BO_ACTIVATE_AND_DEACTIVATE_PROFILE',
  USR_BO_CREATE_PROFILE: 'USR_BO_CREATE_PROFILE',
  USR_BO_ACCESS_PROFILE_MANAGEMENT: 'USR_BO_ACCESS_PROFILE_MANAGEMENT',
  USR_BO_ACCESS_USER_MANAGEMENT: 'USR_BO_ACCESS_USER_MANAGEMENT',
  USR_BO_CREATE_USER: 'USR_BO_CREATE_USER',
  USR_BO_ACCESS_DEVICE_MANAGEMENT: 'USR_BO_ACCESS_DEVICE_MANAGEMENT',
  PAR_BO_ACCESS: 'PAR_BO_ACCESS',
  PAR_BO_WRITE: 'PAR_BO_WRITE',
  PAR_BO_IMPORT: 'PAR_BO_IMPORT',
  RGH_BO_ACCESS_RIGHT_MANAGEMENT: 'RGH_BO_ACCESS_RIGHT_MANAGEMENT',
  RGH_BO_READ_RIGHT: 'RGH_BO_READ_RIGHT',
  RGH_BO_WRITE_RIGHT: 'RGH_BO_WRITE_RIGHT',
  DIV_BO_ACCESS_DivisionManager: 'DIV_BO_ACCESS_DivisionManager',
  DIV_BO_CREATE_Divisions: 'DIV_BO_CREATE_Divisions',
  DIV_BO_WRITE_Divisions: 'DIV_BO_WRITE_Divisions',
  DIV_BO_CREATE_Sections: 'DIV_BO_CREATE_Sections',
  DIV_BO_WRITE_Sections: 'DIV_BO_WRITE_Sections',
  DIV_BO_DELETE_Sections: 'DIV_BO_DELETE_Sections',
  HIE_BO_ACCESS_HIE_MANAGEMENT_LIST: 'HIE_BO_ACCESS_HIE_MANAGEMENT_LIST',
  HIE_BO_WRITE_HIE_MANAGEMENT: 'HIE_BO_WRITE_HIE_MANAGEMENT',
  HIE_BO_DELETE_HIE_MANAGEMENT: 'HIE_BO_DELETE_HIE_MANAGEMENT',
  HIE_BO_ACCESS_HIE_MANAGEMENT_DETAIL: 'HIE_BO_ACCESS_HIE_MANAGEMENT_DETAIL',
  HIE_BO_ACCESS_HIE_CONFIGURATION: 'HIE_BO_ACCESS_HIE_CONFIGURATION',
  HIE_BO_WRITE_HIE_CONFIGURATION: 'HIE_BO_WRITE_HIE_CONFIGURATION',
  HIE_BO_ACCESS_HIE_NODETYPE_CONFIGURATION: 'HIE_BO_ACCESS_HIE_NODETYPE_CONFIGURATION',
  HIE_BO_WRITE_HIE_NODETYPE_CONFIGURATION: 'HIE_BO_WRITE_HIE_NODETYPE_CONFIGURATION',
  USR_BO_LICENSE_MANAGER: 'USR_BO_LICENSE_MANAGER'
};
